module.exports = __webpack_public_path__ + "img/reglamentoadultoexhibicion.852c3431.png";